export default __webpack_public_path__ + "static/media/project_thumbnail_runlabs.648cafef.png";